import { useContext, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import AuthContext from "./Context/AuthProvider";
import { Links } from "./Utility/Constants";

function DashboardSubMenuHeader(props) {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const schedulingEfficiencySubMenu = useRef();
  const patientExperienceSubMenu = useRef();

  const path = location.pathname;

  const SUBMENU_HIGHLIGHTED = "submenu-highlighted";

  useEffect(() => {
    switch (path) {
        
      case Links.patientAnalytics:
        schedulingEfficiencySubMenu?.current?.classList?.remove(SUBMENU_HIGHLIGHTED);
        patientExperienceSubMenu?.current?.classList?.add(SUBMENU_HIGHLIGHTED);
        break;
      case Links.root:
      case Links.schedulingAnalytics:
          schedulingEfficiencySubMenu?.current?.classList?.add(SUBMENU_HIGHLIGHTED);
          patientExperienceSubMenu?.current?.classList?.remove(SUBMENU_HIGHLIGHTED);
        break;
      default:
        break;
    }
  }, [path, schedulingEfficiencySubMenu?.classList, patientExperienceSubMenu?.classList]);

  return (
    <>
      {/* {props.mainMenu ? ( */}
        <>
          <div className="Master">
            <div class="container-fluid">
              <div class="row d-flex">
                <nav class="navbar navbar-expand-sm px-3">

                  <div
                    class="collapse navbar-collapse d-flex justify-content-start"
                    id="collapsibleNavId"
                  >
                    <ul class="navbar-nav">
                      <li class="nav-item">
                        <Link
                          class="nav-link"
                          ref={schedulingEfficiencySubMenu}
                          to={Links.schedulingAnalytics}
                          style={{color:'#06adaf'}}
                        >
                          Scheduling Analytics
                        </Link>
                      </li>
                      <div class="nav-item">
                        <Link
                          class="nav-link"
                          ref={patientExperienceSubMenu}
                          to={Links.patientAnalytics}
                          style={{color:'#06adaf'}}
                        >
                          Patient Analytics
                        </Link>
                      </div>
                    </ul>
                  </div>
                </nav>
              </div>
              <div>
                {(() => {
                  if(path === Links.patientAnalytics)
                    {
                      <label> Patient experience dashboard is under construction.
                      </label>
                    }
                })
                }
              </div>
            </div>
          </div>
        </>
    </>
  );
}

export default DashboardSubMenuHeader;
